import { Label } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import {
  PiBarcode,
  PiCheckCircle,
  PiGlobeHemisphereWest,
  PiHourglass,
  PiMinusCircle,
  PiQuestion,
  PiQuestionMark,
  PiWarning,
  PiX,
  PiXCircle,
} from 'react-icons/pi';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { ILabeledStatusParams, ILabeledStatusProps } from './LabeledStatus';

const labeledStatusParams: ILabeledStatusParams<DELIVERY_STATUS>[] = [
  {
    status: DELIVERY_STATUS.unknown,
    color: 'gray',
    icon: <PiQuestionMark />,
  },
  {
    status: DELIVERY_STATUS.notSend,
    color: 'black',
    icon: <PiMinusCircle />,
  },
  {
    status: DELIVERY_STATUS.waiting,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.inProgress,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.published,
    color: 'green',
    icon: <PiCheckCircle />,
  },
  {
    status: DELIVERY_STATUS.error,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.canceled,
    color: 'gray',
    icon: <PiXCircle />,
  },
  {
    status: DELIVERY_STATUS.waitingForACKFile,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.inProgressProcessingACKFile,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.errorProcessingACKFile,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.ACKFileError,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.withdrawWaiting,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.publishWaiting,
    color: 'blue',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.published,
    color: 'blue',
    icon: <PiGlobeHemisphereWest />,
  },
  {
    status: DELIVERY_STATUS.waitingForAssetIds,
    color: 'blue',
    icon: <PiBarcode />,
  },
  {
    status: DELIVERY_STATUS.inProgressAssigningAssetIds,
    color: 'blue',
    icon: <PiBarcode />,
  },
  {
    status: DELIVERY_STATUS.errorAssigningAssetIds,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.withdrawInProgress,
    color: 'orange',
    icon: <PiHourglass />,
  },
  {
    status: DELIVERY_STATUS.withdrawn,
    color: 'gray',
    icon: <PiXCircle />,
  },
  {
    status: DELIVERY_STATUS.withdrawError,
    color: 'red',
    icon: <PiWarning />,
  },
  {
    status: DELIVERY_STATUS.unavailable,
    color: 'gray',
    icon: <PiX />,
  },
  {
    status: DELIVERY_STATUS.waitingForAccept,
    color: 'orange',
    icon: <PiQuestion />,
  },
  {
    status: DELIVERY_STATUS.withdrawWaitingForAccept,
    color: 'orange',
    icon: <PiQuestion />,
  },
];

const LabeledDeliveryStatus = ({
  status,
}: ILabeledStatusProps<DELIVERY_STATUS>) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(
        `enum.DELIVERY_STATUS.${DELIVERY_STATUS[labeledParams.status]}`
      )}>
      {labeledParams.icon}{' '}
      {t(`enum.DELIVERY_STATUS.${DELIVERY_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledDeliveryStatus;
